export const DELIMITER = '|';
export const AND_DELIMITER = '&';
export const EQUAL_DELIMITER = '=';